import React from "react";

function ProjectCard(props) {
  let {tags, title, para, img} = props;
  if(!(tags|| title|| para|| img)){
    return null
  }
  let tagsContent = tags
    ? tags.map((tag, index) => (
        <span className="tag" key={index}>
          {tag.name}
        </span>
      ))
    : null;
  return (
    <div className="max-w-xs m-2">
      <div className="shadow-md border rounded-lg max-w-sm bg-gray-800 border-gray-700">
        <div>
          <img
            className="rounded-t-lg"
            src={img}
            alt=""
          />
        </div>
        <div className="p-5">
          <div className="flex flex-wrap">{tagsContent}</div>
          <div>
            <h5 className="font-bold text-2xl tracking-tight mb-2 text-white">
              {title}
            </h5>
          </div>
          <p className="font-normal mb-3 text-gray-400">
            {para}
          </p>
          {/* <div className="text-white focus:ring-4 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center  bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">
            Read more
            <svg
              className="-mr-1 ml-2 h-4 w-4"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
